export default __webpack_public_path__ + "static/media/view-list.e5580f24.svg";